import { useQuery } from '@tanstack/react-query';
import * as projectTestResultApi from '../services/projectTestResultService';

export const projectTestResultKeys = {
  rounds: (projectId: string) => ['projectTestResults', projectId, 'rounds'] as const,
  roundDetail: (projectId: string, roundNumber: number) =>
    ['projectTestResults', projectId, 'rounds', roundNumber] as const,
  issueDashboard: (projectId: string) => ['issueDashboard', projectId] as const,
};

/** 프로젝트 회차 목록 조회 */
export function useRounds(projectId: string) {
  return useQuery({
    queryKey: projectTestResultKeys.rounds(projectId),
    queryFn: () => projectTestResultApi.fetchRounds(projectId),
    enabled: !!projectId,
  });
}

/** 특정 회차 상세 조회 */
export function useRoundDetail(projectId: string, roundNumber: number) {
  return useQuery({
    queryKey: projectTestResultKeys.roundDetail(projectId, roundNumber),
    queryFn: () => projectTestResultApi.fetchRoundDetail(projectId, roundNumber),
    enabled: !!projectId && roundNumber > 0,
  });
}

/** 이슈 대시보드 조회 */
export function useIssueDashboard(projectId: string) {
  return useQuery({
    queryKey: projectTestResultKeys.issueDashboard(projectId),
    queryFn: () => projectTestResultApi.fetchIssueDashboard(projectId),
    enabled: !!projectId,
  });
}
